export const findObjectGeom = function(component, item) {
  const features = component.layersData[item.layer_id];
  if (!features) return false;
  const feature = features.find(e => e.id === item.id);
  if (!feature) return false;
  const geom = feature.geom;

  return geom || null;
};
